import { render, staticRenderFns } from "./pmtTariffList.vue?vue&type=template&id=f01fa056&"
import script from "./pmtTariffList.vue?vue&type=script&lang=js&"
export * from "./pmtTariffList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports